import { render, staticRenderFns } from "./smartTourism.vue?vue&type=template&id=55b43d44&scoped=true"
import script from "./smartTourism.vue?vue&type=script&lang=js"
export * from "./smartTourism.vue?vue&type=script&lang=js"
import style0 from "./smartTourism.vue?vue&type=style&index=0&id=55b43d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b43d44",
  null
  
)

export default component.exports